import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import AdmissionAdditionalServiceFields from './AdmissionAdditionalServiceFields'

export const AdmissionAdditionalServiceCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <AdmissionAdditionalServiceFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default AdmissionAdditionalServiceCreate
